// extracted by mini-css-extract-plugin
export default {"card":"f0-z","carouselContainer":"g0-z","carouselContent":"h0-z"};